export const ID_ITALIAN_NATION = 90;

export const DESCRIPTION_ITALIAN_NATION = 'ITALIA';
